/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin
     */
    Url: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin
     */
    Identifiers: { [key: string]: string; };
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin {
    if (!('Url' in value) || value['Url'] === undefined) return false;
    if (!('Identifiers' in value) || value['Identifiers'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin {
    if (json == null) {
        return json;
    }
    return {
        
        'Url': json['url'],
        'Identifiers': json['identifiers'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['Url'],
        'identifiers': value['Identifiers'],
    };
}

